import {
  observeAutoHeight,
} from "../common";

export const initCustomArchive = () => {
  observeAutoHeight("js-new-post-item-ttl", {
    containerSelector: ".post-card__items",
    columnPc: 3,
    columnSp: 2
  });
}

export const initInterviewArchive = () => {
  // window.addEventListener("resize", resizeWindow);

  // function resizeWindow() {
  //   observeAutoHeight("js-new-post-item-ttl", {
  //     containerSelector: ".post-card__items",
  //     columnPc: 3,
  //     columnSp: 2
  //   });
  // }
  // observeAutoHeight("js-new-post-item-ttl", {
  //   containerSelector: ".post-card__items",
  //   columnPc: 3,
  //   columnSp: 2
  // });
};